import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
const tumblr = _ref => {
  let {
    size,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 643 1000",
    fill: "currentColor",
    width: size || '1em',
    height: size || '1em'
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M523 988c-35 8-73 12-114 12-47 0-75-6-110-17-36-12-67-28-92-50-26-21-43-44-53-68s-15-59-15-105V410H1V268c40-13 86-31 115-55 28-24 51-52 69-86 17-33 29-75 35-127h146v231h236v179H366v256c0 58-1 92 5 108s22 33 39 43c23 13 48 20 78 20 51 0 103-16 154-49v158c-44 20-83 34-119 42z"
  }));
};
tumblr.displayName = 'tumblr';
export default tumblr;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=tumblr.js.map